module.exports = __webpack_public_path__ + "static/media/bevilja.747f2c65.mp3";